"use strict";

const strf = require("./string.format.js");

/*
 *
 * Utilities class
 *
 */

class MetaStreamIOUtils {
  constructor({ constants, date, logger } = {}) {
    this.date = date;
    this.logger = logger;
    this.constant = constants;
  }

  generateRandomId() {
    return (
      String(this.date.getEventTimestamp() * Math.random()) +
      ":" +
      String(Math.floor(1000 + (9999 - 1000) * Math.random()))
    );
  }

  // Check if input is an integer
  isInteger(n) {
    if (n != null) {
      return Math.ceil(parseFloat(n)) === n;
    } else {
      return false;
    }
  }

  // Return the type of a given input
  type_to_name(value) {
    var type = typeof value;
    if (type == "number") {
      if (this.isInteger(value) === true) {
        type = "integer";
      } else {
        type = "float";
      }
    }
    return type;
  }

  // Make a distinct copy of an object
  copyObject(input) {
    try {
      return JSON.parse(JSON.stringify(input));
      // return clone;
    } catch {
      return {};
    }
  }

  // Flatten an object
  flattenArray(source, delimiter = ".", filter) {
    var result = {};
    (function flat(obj, stack) {
      try {
        Object.keys(obj).forEach(function (k) {
          var s = stack.concat([k]);
          var v = obj[k];
          if (filter && filter(k, v)) return;
          if (typeof v === "object") flat(v, s);
          else result[s.join(delimiter)] = v;
        });
      } catch (err) {
        return {};
      }
    })(source, []);
    return result;
  }

  // Compare two objects
  compareArrays({ newArray, oldArray } = {}) {
    var nK = this.flattenArray(newArray);
    var oK = this.flattenArray(oldArray);
    if (Object.keys(nK).length !== Object.keys(oK).length) {
      return true;
    }
    if (nK != null || nK != {}) {
      if (oK != null || oK != {}) {
        for (let x in nK) {
          if (nK[x] !== oK[x]) {
            return true;
          }
        }
      } else {
        return true;
      }
    }
    return false;
  }

  // Convert event object to a list of objects
  eventObjToList(input = {}) {
    var output = [];
    var iK = Object.keys(input);
    if (iK.length > 0) {
      for (let x of iK) {
        let val = {};
        val["key"] = x;
        val["value"] = input[x];
        output.push(val);
      }
    }
    return output;
  }

  // Convert cart object to a list of objects with the bundle id as the key for each
  cartObjToList(input = {}) {
    var output = [];
    var iK = Object.keys(input);
    if (iK.length > 0) {
      for (let x of iK) {
        let bundle = {};
        bundle["bundle_id"] = x;
        let target = Object.assign({}, bundle, input[x]);
        output.push(target);
      }
    }
    return output;
  }

  // Data hygiene: return only input or null
  validateData(input) {
    if (input !== "undefined" && input !== null) {
      return input;
    } else {
      return null;
    }
  }

  setAppId(id) {
    if (typeof id !== "undefined" && id.length > 0) {
      this.logger.log(
        "project",
        this.constant.MetaStreamIO_IO_ProjectIdSet.format(id)
      );
      return id;
    } else {
      this.logger.warn(
        "project",
        this.constant.MetaStreamIO_IO_ProjectIdNotSet
      );
      return null;
    }
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  castEventParameterTypes(eventParameters) {
    try {
      let castEventParameters = [];
      eventParameters.forEach((parameter) => {
        let value_type = this.type_to_name(parameter.value);
        let temp_param = {};
        temp_param["key"] = parameter.key;
        temp_param["value"] = { ["" + value_type]: parameter.value };
        castEventParameters.push(temp_param);
      });
      return castEventParameters;
    } catch (err) {
      return [];
    }
  }

  async checkBlockingProcess(checkVariable) {
    return new Promise(async (resolve, reject) => {
      var max_retries = 5;
      var retry = 0;
      while (checkVariable === false && retry < max_retries) {
        await this.sleep(500);
        retry++;
        continue;
      }
      if (checkVariable === true) {
        resolve(checkVariable);
      } else {
        reject(Object.keys(checkVariable));
      }
    });
  }

  async makeBlockingProcess(checkVariable, fn, args) {
    checkVariable = true;
    let function_call = await fn(args)
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((result) => {
        return Promise.reject(result);
      });
    checkVariable = false;
    return function_call;
  }
}

module.exports = MetaStreamIOUtils;
